export default [
    {
        path: '/users/:id',
        name: 'user',
        component: () => import('../pages/KurccUserPage'),
        props: true,
        meta: {
            auth: true
        }
    }
]
